import React, { useState } from 'react';
import classNames from "classnames";

import { useTranslation } from '@common/hooks/translation';
import NumericKeyboard from '@common/components/numericKeyboard';
import KeyboardInput from "@common/components/InputKeyboard";
import { DocTypeEnum } from '@common/constants/enums/docType';

const DocTypeInput = ({ type, config, value, onChange, errorMessage }) => {
  const t = useTranslation();
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const pattern = /^[0-9]+$/;

  const handleChange = (inputValue, checkPattern = false) => {
    if (!inputValue) onChange(inputValue)

    if (type === DocTypeEnum.DNI) {
      const dniFormat = config.verification.enableDNIFormatting
        ? inputValue.replace(/^(\d{7})(\d{1})$/, '$1-$2')
        : inputValue.substring(0, 10);

      (!checkPattern || pattern.test(inputValue)) && onChange(dniFormat);
    } else onChange(inputValue);
  };

  const onRemove = () => {
    if (!value) return;

    handleChange(value.substring(0, value.length - 1));
  };
  const onKeyboardButtonClick = (sign, isCustomButton) => {
    let newValue = ''

    if (isCustomButton) newValue = config.enableAdditiveLogic ? `${sign}` : `${+value + +sign}`
    else newValue = `${value}${sign}`

    pattern.test(newValue) && handleChange(newValue)
  }
  return (
    <>
      {type === DocTypeEnum.PAS ? (
        <KeyboardInput
          value={value}
          onChange={handleChange}
          class={classNames("verification-input", { "verification-error": errorMessage !== '' })}
          disableSearchIcon
        />
      ) : (
        <input
          value={value}
          onClick={() => setKeyboardOpen(!keyboardOpen)}
          onChange={(e) => handleChange(e.currentTarget.value, true)}
          className={classNames("verification-input", { "verification-error": errorMessage !== '' })}
        />
      )}

      {errorMessage !== '' && <span className="verification-error-message">
        <i className="global-icon icon-error verification-error-message-icon" />
        {t(errorMessage)}
      </span>}

      {keyboardOpen && <NumericKeyboard
        onClick={onKeyboardButtonClick}
        onRemove={onRemove}
        onClose={() => setKeyboardOpen(false)}
      />}
    </>
  );
};

export default DocTypeInput;
